export const BOOKMARKLET_NAME = '密码助手';

function passwordHelperBookmarklet(): void {
  const panelId = 'pgxPasswordHelperPanel';
  const styleId = 'pgxPasswordHelperStyle';
  const existingPanel = document.getElementById(panelId);

  if (existingPanel) {
    existingPanel.remove();
    document.getElementById(styleId)?.remove();
    return;
  }

  const css = `
.pgx-panel,.pgx-panel *{box-sizing:border-box}
.pgx-panel{--pgx-bg:#12151b;--pgx-panel:#f7f4ed;--pgx-ink:#17202a;--pgx-muted:#687381;--pgx-line:#d7d1c4;--pgx-soft:#ebe5da;--pgx-field:#fffdf8;--pgx-accent:#0f766e;--pgx-accent-2:#2563eb;--pgx-warn:#b45309;--pgx-danger:#be123c;position:fixed;top:18px;right:18px;width:392px;max-width:calc(100vw - 24px);max-height:calc(100vh - 24px);display:flex;flex-direction:column;color:var(--pgx-ink);background:linear-gradient(180deg,#fffaf0 0%,var(--pgx-panel) 100%);border:1px solid rgba(23,32,42,.16);border-radius:16px;box-shadow:0 24px 70px rgba(11,18,32,.26),0 2px 8px rgba(11,18,32,.12);z-index:2147483647;font:13px/1.5 "Segoe UI","PingFang SC","Microsoft YaHei",sans-serif;overflow:hidden}
.pgx-head{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:13px 14px 12px;cursor:move;user-select:none;border-bottom:1px solid var(--pgx-line);background:linear-gradient(90deg,#1f2937,#263241)}
.pgx-title{display:flex;flex-direction:column;min-width:0;color:#fff}
.pgx-title strong{font-size:15px;line-height:1.2;letter-spacing:0;font-weight:800}
.pgx-title span{font-size:11px;color:#cbd5e1}
.pgx-close{width:30px;height:30px;display:grid;place-items:center;border:1px solid rgba(255,255,255,.2);border-radius:10px;background:rgba(255,255,255,.08);color:#fff;cursor:pointer;font:700 18px/1 sans-serif}
.pgx-close:hover{background:rgba(244,63,94,.24);border-color:rgba(255,255,255,.35)}
.pgx-main{min-height:0;overflow:auto;padding:13px}
.pgx-tabs{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px;padding:4px;margin-bottom:12px;border:1px solid var(--pgx-line);border-radius:13px;background:var(--pgx-soft)}
.pgx-tab{min-height:36px;border:0;border-radius:9px;background:transparent;color:#445063;cursor:pointer;font:800 12px/1 "Segoe UI","PingFang SC","Microsoft YaHei",sans-serif}
.pgx-tab.is-active{background:#1f2937;color:#fff;box-shadow:0 7px 16px rgba(31,41,55,.18)}
.pgx-view[hidden]{display:none}
.pgx-output{display:grid;grid-template-columns:minmax(0,1fr)42px;gap:8px;margin-bottom:10px}
.pgx-input{min-width:0;width:100%;height:42px;border:1px solid var(--pgx-line);border-radius:11px;padding:0 11px;background:var(--pgx-field);color:var(--pgx-ink);outline:none;font:700 12px/1.4 Consolas,"SFMono-Regular",monospace}
.pgx-copy,.pgx-primary,.pgx-small{border:0;cursor:pointer;font:800 12px/1 "Segoe UI","PingFang SC","Microsoft YaHei",sans-serif;transition:transform .15s ease,filter .15s ease}
.pgx-copy{height:42px;border-radius:11px;background:#1f2937;color:#fff}
.pgx-copy.is-copied{background:#15803d}
.pgx-primary{width:100%;min-height:42px;border-radius:12px;background:linear-gradient(90deg,var(--pgx-accent),#115e59);color:#fff;box-shadow:0 10px 22px rgba(15,118,110,.18)}
.pgx-primary:hover,.pgx-copy:hover,.pgx-small:hover{transform:translateY(-1px);filter:brightness(1.04)}
.pgx-meter{margin-bottom:13px}
.pgx-meter-bar{height:6px;overflow:hidden;border-radius:999px;background:#ded8cd}
.pgx-meter-bar span{display:block;width:0;height:100%;border-radius:inherit;background:var(--pgx-danger);transition:width .2s ease,background .2s ease}
.pgx-meter.is-medium .pgx-meter-bar span{width:68%;background:var(--pgx-warn)}
.pgx-meter.is-strong .pgx-meter-bar span{width:100%;background:#15803d}
.pgx-meter.is-weak .pgx-meter-bar span{width:34%;background:var(--pgx-danger)}
.pgx-meter-text{display:block;margin-top:5px;color:var(--pgx-muted);font-size:11px}
.pgx-block{padding:11px;border:1px solid var(--pgx-line);border-radius:13px;background:rgba(255,255,255,.52);margin-bottom:10px}
.pgx-label-row{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:8px;color:#334155;font-weight:800;font-size:12px}
.pgx-range{width:100%;margin:0;accent-color:var(--pgx-accent)}
.pgx-checks,.pgx-choice-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}
.pgx-check,.pgx-choice{display:flex;align-items:center;gap:7px;min-height:36px;padding:8px 9px;border:1px solid var(--pgx-line);border-radius:10px;background:var(--pgx-field);color:#334155;font-weight:700;font-size:12px;cursor:pointer}
.pgx-check input{margin:0;accent-color:var(--pgx-accent)}
.pgx-choice{justify-content:center}
.pgx-choice input{position:absolute;opacity:0;pointer-events:none}
.pgx-choice:has(input:checked){border-color:rgba(15,118,110,.45);background:#dff7ef;color:#115e59}
.pgx-name-list{display:grid;gap:8px;max-height:160px;overflow:auto;margin:0 0 10px}
.pgx-name{display:grid;grid-template-columns:minmax(0,1fr)52px;gap:8px;align-items:center;padding:8px 9px;border:1px solid var(--pgx-line);border-radius:11px;background:var(--pgx-field)}
.pgx-name span{min-width:0;overflow-wrap:anywhere;font-weight:800;color:#263241}
.pgx-small{height:32px;border-radius:9px;background:#e2e8f0;color:#263241}
.pgx-status{min-height:24px;margin-top:10px;padding:6px 8px;border-radius:9px;background:#ece6da;color:#52606f;font-size:12px}
.pgx-status.is-ok{background:#dcfce7;color:#166534}
.pgx-status.is-error{background:#ffe4e6;color:#9f1239}
@media (max-width:430px){.pgx-panel{top:10px;right:10px;width:calc(100vw - 20px)}.pgx-checks,.pgx-choice-grid{grid-template-columns:1fr}}
@media (prefers-reduced-motion:reduce){.pgx-panel *{transition:none!important}}
`;

  const html = `
<header class="pgx-head">
  <div class="pgx-title"><strong>密码助手</strong><span>书签版</span></div>
  <button class="pgx-close" type="button" aria-label="关闭">×</button>
</header>
<main class="pgx-main">
  <div class="pgx-tabs" role="tablist" aria-label="工具切换">
    <button class="pgx-tab is-active" type="button" data-view="password">密码</button>
    <button class="pgx-tab" type="button" data-view="key">密钥</button>
    <button class="pgx-tab" type="button" data-view="name">姓名</button>
  </div>
  <section class="pgx-view" data-panel="password">
    <div class="pgx-output">
      <input class="pgx-input" id="pgxPasswordValue" type="text" readonly aria-label="当前生成的密码">
      <button class="pgx-copy" id="pgxCopyPassword" type="button" aria-label="复制当前密码">复制</button>
    </div>
    <div class="pgx-meter is-weak" id="pgxStrength"><div class="pgx-meter-bar"><span></span></div><span class="pgx-meter-text">密码强度: --</span></div>
    <div class="pgx-block">
      <div class="pgx-label-row"><span>长度</span><output id="pgxLengthValue">16</output></div>
      <input class="pgx-range" id="pgxLength" type="range" min="8" max="32" value="16">
    </div>
    <div class="pgx-block pgx-checks">
      <label class="pgx-check"><input class="pgx-charset" type="checkbox" data-key="uppercase" checked>大写</label>
      <label class="pgx-check"><input class="pgx-charset" type="checkbox" data-key="lowercase" checked>小写</label>
      <label class="pgx-check"><input class="pgx-charset" type="checkbox" data-key="numbers" checked>数字</label>
      <label class="pgx-check"><input class="pgx-charset" type="checkbox" data-key="symbols" checked>符号</label>
    </div>
    <button class="pgx-primary" id="pgxGeneratePassword" type="button">生成密码</button>
  </section>
  <section class="pgx-view" data-panel="key" hidden>
    <div class="pgx-output">
      <input class="pgx-input" id="pgxKeyValue" type="text" readonly aria-label="当前随机密钥">
      <button class="pgx-copy" id="pgxCopyKey" type="button" aria-label="复制当前随机密钥">复制</button>
    </div>
    <div class="pgx-block"><div class="pgx-label-row"><span>格式</span><span>Hex · 32 位</span></div></div>
    <button class="pgx-primary" id="pgxGenerateKey" type="button">生成密钥</button>
  </section>
  <section class="pgx-view" data-panel="name" hidden>
    <div class="pgx-block">
      <div class="pgx-label-row"><span>性别</span><span>5 个</span></div>
      <div class="pgx-choice-grid">
        <label class="pgx-choice"><input type="radio" name="pgxGender" value="male">男</label>
        <label class="pgx-choice"><input type="radio" name="pgxGender" value="female">女</label>
        <label class="pgx-choice"><input type="radio" name="pgxGender" value="random" checked>随机</label>
      </div>
    </div>
    <div class="pgx-block">
      <div class="pgx-label-row"><span>格式</span></div>
      <div class="pgx-choice-grid">
        <label class="pgx-choice"><input type="radio" name="pgxFormat" value="firstLast" checked>名 + 姓</label>
        <label class="pgx-choice"><input type="radio" name="pgxFormat" value="lastFirst">姓, 名</label>
      </div>
    </div>
    <div class="pgx-name-list" id="pgxNameList"></div>
    <button class="pgx-primary" id="pgxGenerateNames" type="button">生成姓名</button>
  </section>
  <div class="pgx-status" id="pgxStatus" role="status" aria-live="polite">面板已就绪</div>
</main>`;

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = css;
  document.head.append(style);

  const panel = document.createElement('section');
  panel.id = panelId;
  panel.className = 'pgx-panel';
  panel.setAttribute('aria-label', '密码助手书签面板');
  panel.innerHTML = html;
  (document.body || document.documentElement).append(panel);

  type PasswordKey = 'uppercase' | 'lowercase' | 'numbers' | 'symbols';
  type Strength = { level: 'weak' | 'medium' | 'strong'; text: string };
  type NameGender = 'male' | 'female' | 'random';
  type NameFormat = 'firstLast' | 'lastFirst';

  const charSets: Record<PasswordKey, string> = {
    uppercase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    lowercase: 'abcdefghijklmnopqrstuvwxyz',
    numbers: '0123456789',
    symbols: '!@#$%^&*()_+-=[]{}|;:,.<>?'
  };
  const firstNames = {
    male: ['James', 'John', 'Robert', 'Michael', 'William', 'David', 'Richard', 'Joseph', 'Thomas', 'Charles', 'Daniel', 'Matthew', 'Anthony', 'Mark', 'Andrew', 'Joshua', 'Ryan', 'Samuel', 'Patrick', 'Eric'],
    female: ['Mary', 'Patricia', 'Jennifer', 'Linda', 'Elizabeth', 'Barbara', 'Susan', 'Jessica', 'Sarah', 'Karen', 'Nancy', 'Lisa', 'Ashley', 'Emily', 'Emma', 'Nicole', 'Rachel', 'Catherine', 'Maria', 'Anna']
  };
  const lastNames = ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Rodriguez', 'Martinez', 'Wilson', 'Anderson', 'Taylor', 'Moore', 'Jackson', 'Martin', 'Lee', 'Perez', 'White', 'Harris', 'Clark', 'Lewis', 'Young', 'King', 'Scott', 'Hill', 'Green', 'Baker', 'Hall', 'Rivera'];

  function query<T extends Element>(selector: string): T {
    const element = panel.querySelector<T>(selector);
    if (!element) {
      throw new Error(`未找到元素: ${selector}`);
    }
    return element;
  }

  function randomInt(max: number): number {
    if (!globalThis.crypto?.getRandomValues) {
      throw new Error('当前页面不支持安全随机源');
    }

    const values = new Uint32Array(1);
    const limit = Math.floor(0x100000000 / max) * max;
    let value = 0;

    do {
      globalThis.crypto.getRandomValues(values);
      value = values[0];
    } while (value >= limit);

    return value % max;
  }

  function pick<T>(items: readonly T[]): T {
    return items[randomInt(items.length)];
  }

  function pickCharacter(characters: string): string {
    return characters[randomInt(characters.length)];
  }

  function shuffle(value: string): string {
    const items = Array.from(value);

    for (let index = items.length - 1; index > 0; index -= 1) {
      const targetIndex = randomInt(index + 1);
      [items[index], items[targetIndex]] = [items[targetIndex], items[index]];
    }

    return items.join('');
  }

  function selectedPasswordKeys(): PasswordKey[] {
    return Array.from(panel.querySelectorAll<HTMLInputElement>('.pgx-charset:checked'))
      .map((input) => input.dataset.key as PasswordKey)
      .filter(Boolean);
  }

  function calculateStrength(password: string): Strength {
    let poolSize = 0;

    if (/[A-Z]/.test(password)) poolSize += 26;
    if (/[a-z]/.test(password)) poolSize += 26;
    if (/[0-9]/.test(password)) poolSize += 10;
    if (/[^A-Za-z0-9]/.test(password)) poolSize += 28;

    const entropyBits = password.length * Math.log2(Math.max(poolSize, 1));

    if (entropyBits < 60) return { level: 'weak', text: '密码强度: 弱' };
    if (entropyBits < 80) return { level: 'medium', text: '密码强度: 中' };
    return { level: 'strong', text: '密码强度: 强' };
  }

  function showStatus(text: string, type: 'ok' | 'error' | 'info' = 'info'): void {
    const status = query<HTMLElement>('#pgxStatus');
    status.textContent = text;
    status.className = `pgx-status${type === 'ok' ? ' is-ok' : ''}${type === 'error' ? ' is-error' : ''}`;
  }

  function generatePassword(): string {
    const length = Number.parseInt(query<HTMLInputElement>('#pgxLength').value, 10);
    const keys = selectedPasswordKeys();

    if (keys.length === 0) throw new Error('请至少选择一种字符类型');
    if (length < keys.length) throw new Error('长度不能小于字符类型数量');

    const required = keys.map((key) => pickCharacter(charSets[key]));
    const allCharacters = keys.map((key) => charSets[key]).join('');

    while (required.length < length) {
      required.push(pickCharacter(allCharacters));
    }

    return shuffle(required.join(''));
  }

  function renderPassword(): void {
    try {
      const password = generatePassword();
      query<HTMLInputElement>('#pgxPasswordValue').value = password;
      const strength = calculateStrength(password);
      const meter = query<HTMLElement>('#pgxStrength');
      meter.className = `pgx-meter is-${strength.level}`;
      query<HTMLElement>('.pgx-meter-text').textContent = strength.text;
      showStatus('密码已生成', 'ok');
    } catch (error) {
      showStatus(error instanceof Error ? error.message : '密码生成失败', 'error');
    }
  }

  function generateKey(): string {
    const bytes = new Uint8Array(16);
    globalThis.crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  }

  function renderKey(): void {
    try {
      query<HTMLInputElement>('#pgxKeyValue').value = generateKey();
      showStatus('密钥已生成', 'ok');
    } catch (error) {
      showStatus(error instanceof Error ? error.message : '密钥生成失败', 'error');
    }
  }

  function readRadio(name: string): string {
    return query<HTMLInputElement>(`input[name="${name}"]:checked`).value;
  }

  function generateSingleName(gender: NameGender, format: NameFormat): string {
    const pool = gender === 'random'
      ? (randomInt(2) === 0 ? firstNames.male : firstNames.female)
      : firstNames[gender];
    const firstName = pick(pool);
    const lastName = pick(lastNames);
    return format === 'lastFirst' ? `${lastName}, ${firstName}` : `${firstName} ${lastName}`;
  }

  function renderNames(): void {
    try {
      const list = query<HTMLElement>('#pgxNameList');
      const gender = readRadio('pgxGender') as NameGender;
      const format = readRadio('pgxFormat') as NameFormat;
      const names = new Set<string>();

      while (names.size < 5) {
        names.add(generateSingleName(gender, format));
      }

      list.replaceChildren(...Array.from(names, (name) => {
        const item = document.createElement('div');
        const text = document.createElement('span');
        const button = document.createElement('button');
        item.className = 'pgx-name';
        text.textContent = name;
        button.className = 'pgx-small';
        button.type = 'button';
        button.textContent = '复制';
        button.setAttribute('aria-label', `复制姓名 ${name}`);
        button.addEventListener('click', () => copyValue(name, button));
        item.append(text, button);
        return item;
      }));
      showStatus('姓名已生成', 'ok');
    } catch (error) {
      showStatus(error instanceof Error ? error.message : '姓名生成失败', 'error');
    }
  }

  async function writeClipboard(text: string): Promise<boolean> {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch {
        // 继续尝试兼容回退逻辑
      }
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', 'true');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '0';
    document.body.append(textarea);
    textarea.focus();
    textarea.select();

    try {
      return document.execCommand('copy');
    } finally {
      textarea.remove();
    }
  }

  async function copyValue(text: string, button: HTMLButtonElement): Promise<void> {
    if (!text) {
      showStatus('没有可复制内容', 'error');
      return;
    }

    const copied = await writeClipboard(text);

    if (!copied) {
      showStatus('复制失败，请手动选择内容', 'error');
      return;
    }

    const originalText = button.textContent || '复制';
    button.textContent = '已复制';
    button.classList.add('is-copied');
    showStatus('已复制到剪贴板', 'ok');
    setTimeout(() => {
      button.textContent = originalText;
      button.classList.remove('is-copied');
    }, 1400);
  }

  function activateView(view: string): void {
    panel.querySelectorAll<HTMLButtonElement>('.pgx-tab').forEach((button) => {
      button.classList.toggle('is-active', button.dataset.view === view);
    });
    panel.querySelectorAll<HTMLElement>('.pgx-view').forEach((viewPanel) => {
      viewPanel.hidden = viewPanel.dataset.panel !== view;
    });
  }

  function setupDrag(): void {
    const header = query<HTMLElement>('.pgx-head');
    let dragging = false;
    let offsetX = 0;
    let offsetY = 0;

    header.addEventListener('pointerdown', (event) => {
      if ((event.target as Element).closest('button')) return;
      const rect = panel.getBoundingClientRect();
      dragging = true;
      offsetX = event.clientX - rect.left;
      offsetY = event.clientY - rect.top;
      panel.style.left = `${rect.left}px`;
      panel.style.top = `${rect.top}px`;
      panel.style.right = 'auto';
      header.setPointerCapture(event.pointerId);
    });

    header.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const left = Math.max(0, Math.min(window.innerWidth - panel.offsetWidth, event.clientX - offsetX));
      const top = Math.max(0, Math.min(window.innerHeight - panel.offsetHeight, event.clientY - offsetY));
      panel.style.left = `${left}px`;
      panel.style.top = `${top}px`;
    });

    header.addEventListener('pointerup', () => {
      dragging = false;
    });
    header.addEventListener('pointercancel', () => {
      dragging = false;
    });
  }

  query<HTMLButtonElement>('.pgx-close').addEventListener('click', () => {
    panel.remove();
    style.remove();
  });
  panel.querySelectorAll<HTMLButtonElement>('.pgx-tab').forEach((button) => {
    button.addEventListener('click', () => activateView(button.dataset.view || 'password'));
  });
  query<HTMLInputElement>('#pgxLength').addEventListener('input', (event) => {
    query<HTMLOutputElement>('#pgxLengthValue').value = (event.target as HTMLInputElement).value;
  });
  panel.querySelectorAll<HTMLInputElement>('.pgx-charset').forEach((input) => {
    input.addEventListener('change', () => {
      if (selectedPasswordKeys().length === 0) {
        input.checked = true;
        showStatus('请至少选择一种字符类型', 'error');
      }
    });
  });
  query<HTMLButtonElement>('#pgxGeneratePassword').addEventListener('click', renderPassword);
  query<HTMLButtonElement>('#pgxCopyPassword').addEventListener('click', () => {
    copyValue(query<HTMLInputElement>('#pgxPasswordValue').value, query<HTMLButtonElement>('#pgxCopyPassword'));
  });
  query<HTMLButtonElement>('#pgxGenerateKey').addEventListener('click', renderKey);
  query<HTMLButtonElement>('#pgxCopyKey').addEventListener('click', () => {
    copyValue(query<HTMLInputElement>('#pgxKeyValue').value, query<HTMLButtonElement>('#pgxCopyKey'));
  });
  query<HTMLButtonElement>('#pgxGenerateNames').addEventListener('click', renderNames);

  setupDrag();
  renderKey();
  renderNames();
  renderPassword();
}

export const PASSWORD_HELPER_BOOKMARKLET = `javascript:${encodeURIComponent(`(${passwordHelperBookmarklet.toString()})();`)}`;
